import { render } from "./RelatedDocumentsSection.vue?vue&type=template&id=48c052cc&scoped=true&ts=true&lang=pug"
import script from "./RelatedDocumentsSection.vue?vue&type=script&lang=ts"
export * from "./RelatedDocumentsSection.vue?vue&type=script&lang=ts"

import "./RelatedDocumentsSection.vue?vue&type=style&index=0&id=48c052cc&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c052cc"]])

export default __exports__